import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["itemRightContent", "description", "children", "stylesForDescription"];
import { Box, MenuItem as MuiMenuItem, useTheme } from '@mui/material';
import React from 'react';
import Typography from '../Typography';
import { designTokens } from '../index';

var MenuItem = function MenuItem(_ref) {
  var itemRightContent = _ref.itemRightContent,
      description = _ref.description,
      children = _ref.children,
      stylesForDescription = _ref.stylesForDescription,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var isDark = theme.palette.mode === 'dark';

  var RenderContent = function RenderContent() {
    return children ? /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        alignItems: 'center'
      }
    }, children) : /*#__PURE__*/React.createElement(Typography, null, rest.value);
  };

  return /*#__PURE__*/React.createElement(MuiMenuItem, rest, description || itemRightContent ? /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      width: '100%',
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, /*#__PURE__*/React.createElement(RenderContent, null), description && /*#__PURE__*/React.createElement(Box, {
    sx: _objectSpread({}, stylesForDescription && _objectSpread({}, stylesForDescription))
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    variant: "caption",
    color: isDark ? designTokens.colors.darkEmphasisMedium : designTokens.colors.lightEmphasisMedium,
    noWrap: true
  }, description))), itemRightContent && /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      marginLeft: '10px'
    }
  }, itemRightContent(rest.value))) : children || /*#__PURE__*/React.createElement(Typography, null, rest.value));
};

export default MenuItem;
//# sourceMappingURL=index.js.map